// extracted by mini-css-extract-plugin
export default {"edit":"Passengers_edit__cPbQo","cancel":"Passengers_cancel__6P4nO"};